import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { UserButton } from "@/components/shared/UserButton";
import { SearchCommand } from "@/components/shared/SearchCommand";
import { MobileNav } from "@/components/shared/MobileNav";
import { NotificationSystem } from "@/components/shared/NotificationSystem";
import { useAuth } from "@/hooks/useAuth";
import { Search, Menu, BookOpen, Target, Home } from "lucide-react";

const Header = () => {
  const { user } = useAuth();
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <header className="border-b border-gray-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 font-bold text-xl text-black">
            <BookOpen className="h-6 w-6" />
            <span>The Academy</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            {user ? (
              <>
                <Link 
                  to="/dashboard" 
                  className="text-sm font-medium text-black hover:text-black transition-colors flex items-center gap-1"
                >
                  <BookOpen className="h-4 w-4" />
                  Dashboard
                </Link>
                <Link 
                  to="/search" 
                  className="text-sm font-medium text-black hover:text-black transition-colors flex items-center gap-1"
                >
                  <Search className="h-4 w-4" />
                  Search
                </Link>
                <Link 
                  to="/convergence" 
                  className="text-sm font-medium text-black hover:text-black transition-colors flex items-center gap-1"
                >
                  <Target className="h-4 w-4" />
                  Convergence
                </Link>
              </>
            ) : (
              <>
                <Link 
                  to="/search" 
                  className="text-sm font-medium text-black hover:text-black transition-colors flex items-center gap-1"
                >
                  <Search className="h-4 w-4" />
                  Search
                </Link>
                <Link 
                  to="/convergence" 
                  className="text-sm font-medium text-black hover:text-black transition-colors flex items-center gap-1"
                >
                  <Target className="h-4 w-4" />
                  Convergence
                </Link>
              </>
            )}
          </nav>

          {/* Right Side Actions */}
          <div className="flex items-center space-x-3">
            {/* Search Button */}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setSearchOpen(true)}
              className="hidden sm:flex text-black hover:text-black hover:bg-white"
            >
              <Search className="h-4 w-4" />
              <span className="sr-only">Search</span>
            </Button>

            {/* Notifications (for authenticated users only) */}
            {user && (
              <NotificationSystem className="hidden sm:block" />
            )}

            {/* Universal User Button */}
            <UserButton variant="compact" />

            {/* Mobile Menu Button */}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
              className="md:hidden text-black hover:text-black hover:bg-white"
            >
              <Menu className="h-4 w-4" />
              <span className="sr-only">Menu</span>
            </Button>
          </div>
        </div>
      </div>

      {/* Search Command */}
      <SearchCommand open={searchOpen} onOpenChange={setSearchOpen} />

      {/* Mobile Navigation */}
      <MobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
    </header>
  );
};

export default Header;
